import React from 'react';
import Loader from 'react-loader-spinner';

import NotificationCard from './NotificationCard';

const Notifications = ({ toggleNotification, notices }) => {
  return (
    <>
      <div className={toggleNotification ? 'show' : 'hidden'}>
        <div className="fixed z-50 right-0 mx-1 md:mr-6 mt-20">
          <div
            className={`relative notification-bar mt-3 bg-white rounded-sm w-full md:w-110 shadow-cfw overflow-y-scroll ${
              notices.length === 0 ? 'h-24' : 'h-85'
            }`}
          >
            <div className="fixed bg-white h-10 border-b border-gray-200 px-8 flex items-center w-full md:w-110">
              <p className="font-header">Notifications</p>
            </div>
            {notices.length === 0 ? (
              <div className="flex items-center justify-center mt-12">
                <Loader
                  type="TailSpin"
                  color="#3c9130"
                  height={20}
                  width={20}
                  timeout={notices.length > 0 || 0} //3 secs
                />
              </div>
            ) : (
              <div className="mt-10">
                {notices.map(notice => (
                  <NotificationCard key={notice._id} notice={notice} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Notifications;
